import userConstants from '../constants/user.constants';
import utils from '../helpers/utils';

const userReducer = utils.createSetterReducer(
    { setAction: userConstants.SET, initValue: null, clearAction: userConstants.REMOVE },
);

export default userReducer;
